import React, { useState, useEffect, useRef } from "react";
import LaunchingIcon1 from "../../assets/img/launching-icon1.svg";
import LaunchingIcon2 from "../../assets/img/launching-icon2.svg";
import LaunchingIcon3 from "../../assets/img/launching-icon3.svg";
// import LaunchingIcon4 from "../../assets/img/launching-icon4.svg";
import LaunchingIcon5 from "../../assets/img/launching-icon5.svg";
import LaunchingIcon6 from "../../assets/img/launching-icon6.svg";
import ConsecteturLeft from "../../assets/img/consectetur-img.png";
import Mock from "../../assets/img/mock.png";
import Accordion from "react-bootstrap/Accordion";
import WaitlistPopup from "../../Components/WaitlistPopup";
import closeicon from "../../assets/img/close_icon.svg";
import LaunchingIcon7 from "../../assets/img/launching-icon7.svg";
import whoitsicon1 from "../../assets/img/who-its-icon1.svg";
import whoitsicon2 from "../../assets/img/who-its-icon2.svg";
import whoitsicon3 from "../../assets/img/who-its-icon3.png";
import whoitsicon4 from "../../assets/img/who-its-icon4.svg";
import matchimg1 from "../../assets/img/match_img1.png";
import matchimg2 from "../../assets/img/match_img2.png";
import matchimg3 from "../../assets/img/match_img3.png";
import matchimg4 from "../../assets/img/match_img4.png";
import hearticon from "../../assets/img/heart_icon.svg";
import Subtraction_img from "../../assets/img/Subtraction_img.png";
import Subtraction_img2 from "../../assets/img/Subtraction_img2.png";
import video_play from "../../assets/img/video_play.svg";
import media_img from "../../assets/img/media_img.png";
import media_img2 from "../../assets/img/media_img2.png";
import media_icon1 from "../../assets/img/media_icon1.svg";
import media_icon2 from "../../assets/img/media_icon2.svg";
import media_icon3 from "../../assets/img/media_icon3.svg";
import media_icon4 from "../../assets/img/media_icon4.svg";
import media_icon5 from "../../assets/img/media_icon5.svg";
import media_icon6 from "../../assets/img/media_icon6.png";
// import media_icon6 from "../../assets/img/media_icon6.png";
import media_icon7 from "../../assets/img/media_icon7.svg";
import media_icon8 from "../../assets/img/media_icon8.svg";
import media_icon9 from "../../assets/img/media_icon9.svg";
import media_icon10 from "../../assets/img/media_icon10.svg";
import media_icon11 from "../../assets/img/media_icon11.svg";
import media_icon12 from "../../assets/img/media_icon12.svg";
import media_icon13 from "../../assets/img/media_icon13.svg";
import media_icon14 from "../../assets/img/media_icon14.svg";
import media_icon16 from "../../assets/img/media_icon16.svg";
import media_icon17 from "../../assets/img/media_icon17.svg";
import gmail_icon from "../../assets/img/gmail_icon.svg";
import newLogo from "../../assets/img/new_logo.svg";
import mobile_logo from "../../assets/img/mobile_logo.svg";
import instaIcon2 from "../../assets/img/insta_icon2.svg";
import tiktok_icon2 from "../../assets/img/tiktok_black.svg";
import LhVideo1Thumb from "../../assets/img/lh-video1-thumb.jpg";
import LhVideo2Thumb from "../../assets/img/lh-video2-thumb.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import { motion, useReducedMotion, useInView } from "framer-motion";
import {
  fadeUp,
  fadeUpReduced,
  fadeIn,
  slideInRightReduced,
  scaleIn,
  scaleInReduced,
  stagger,
  staggerSlow,
  EASE,
  VIEWPORT_REVEAL,
} from "../../motion";
import bannerimg from "../../assets/img/Subtraction_1.png";
import Ellipse from "../../assets/img/Ellipse.svg";
import Subtraction_1 from "../../assets/img/Subtraction_1.svg";
import { toast } from "react-toastify";
import FounderVid from "../../assets/vid/banner-vid.mp4";
import LhVideo1 from "../../assets/vid/lh-video1.mp4";
import LhVideo2 from "../../assets/vid/lh-video2.mp4";
import { createPortal } from "react-dom";
// import BackgroundSection from "../../Components/BackgroundSection2";
// import BackgroundSection2 from "../../Components/BackgroundSection2";


function Home() {
  const [showModel, setShowModel] = useState(false);
  const [activeBtn, setActiveBtn] = useState("waitlist");
  const [stepsActive, setStepsActive] = useState(false);

  useEffect(() => {
    if (!stepsActive) return;
    const onScroll = () => setStepsActive(false);
    // wait for the click's smooth scrollIntoView to finish before listening,
    // else its own scroll events clear the class instantly
    const t = setTimeout(() => {
      window.addEventListener("scroll", onScroll, { passive: true });
    }, 900);
    return () => {
      clearTimeout(t);
      window.removeEventListener("scroll", onScroll);
    };
  }, [stepsActive]);
  const [isFounderVideoPlaying, setIsFounderVideoPlaying] = useState(false);
  const founderVideoRef = useRef(null);

  const handleFounderVideoPlay = () => {
    setIsFounderVideoPlaying(true);
    setTimeout(() => {
      if (founderVideoRef.current) {
        founderVideoRef.current.play();
      }
    }, 50);
  };
  const reduce = useReducedMotion();

  // Double-click the mobile feature carousel to pause/resume its autoplay.
  const featureSwiperRef = useRef(null);
  const featureDraggedRef = useRef(false); // true only while actually swiping
  const toggleFeatureAutoplay = () => {
    const sw = featureSwiperRef.current;
    if (!sw?.autoplay) return;
    if (sw.autoplay.paused) sw.autoplay.resume();
    else sw.autoplay.pause();
  };

  // Tapping anywhere outside the carousel resumes its autoplay.
  useEffect(() => {
    const handleOutside = (e) => {
      const sw = featureSwiperRef.current;
      if (sw?.autoplay?.paused && !e.target.closest(".hero-feature-swiper")) {
        sw.autoplay.resume();
      }
    };
    document.addEventListener("touchend", handleOutside);
    document.addEventListener("click", handleOutside);
    return () => {
      document.removeEventListener("touchend", handleOutside);
      document.removeEventListener("click", handleOutside);
    };
  }, []);

  // Hero "what makes us different" cards. Desktop = CSS marquee; mobile = Swiper.
  const heroFeatures = [
    { icon: media_icon17, text: "60-second video introductions" },
    { icon: media_icon1, text: "Continue only if you both want to" },
    { icon: media_icon2, text: "Designed to make rejection feel kinder" },
    { icon: media_icon3, text: "Built to reduce dating app fatigue" },
    { icon: media_icon4, text: "Designed by a registered psychotherapist" },
    { icon: media_icon17, text: "60-second video introductions" },
    { icon: media_icon1, text: "Continue only if you both want to" },
    { icon: media_icon2, text: "Designed to make rejection feel kinder" },
    { icon: media_icon3, text: "Built to reduce dating app fatigue" },
    { icon: media_icon4, text: "Designed by a registered psychotherapist" },
  ];

  // Two real videos; thumbnails are frames taken from each video.
  const behindTheAppSlides = [
    { image: LhVideo1Thumb, caption: "Meet First, Chat Later.", video: LhVideo1 },
    { image: LhVideo2Thumb, caption: "Why I Built LoveHappiness", video: LhVideo2 },
  ];

  // "Behind the app" video popup. Full-screen cover on mobile, centered on desktop.
  const [behindVideo, setBehindVideo] = useState(null); // { src, poster, caption } | null
  const behindVideoRef = useRef(null);

  useEffect(() => {
    if (!behindVideo) return;
    const onKey = (e) => e.key === "Escape" && setBehindVideo(null);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    // start playback; if the browser blocks sound, retry muted
    const v = behindVideoRef.current;
    v?.play()?.catch(() => {
      v.muted = true;
      v.play().catch(() => { });
    });
    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKey);
    };
  }, [behindVideo]);

  const [waitlistEmail, setWaitlistEmail] = useState("");
  const [headingRevealed, setHeadingRevealed] = useState(false);

  // "I'm In" — validate email, then open the waitlist popup with the email
  // prefilled so the user finishes name/phone there (single source of submit).
  const handleWaitlistSubmit = (e) => {
    e.preventDefault();
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const toastOpts = {
      position: "top-right",
      autoClose: 6000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    };
    if (waitlistEmail.trim() === "") {
      toast.error("Please enter your email", toastOpts);
      return;
    }
    if (!isValidEmail(waitlistEmail)) {
      toast.error("Enter a valid email", toastOpts);
      return;
    }
    setActiveBtn("waitlist");
    setShowModel(true);
  };

  // Reduced-motion-aware variants
  const vFadeUp = reduce ? fadeUpReduced : fadeUp;
  const vScale = reduce ? scaleInReduced : scaleIn;

  // Card icon settles just after its card lands
  const iconReveal = reduce
    ? fadeUpReduced
    : {
      hidden: { opacity: 0, scale: 0.9 },
      show: { opacity: 1, scale: 0.9, transition: { duration: 0.3, ease: EASE, delay: 0.1 } },
    };

  // Hover lift shared by card sections (Task 3 + Task 5)
  const cardHover = reduce ? undefined : { y: -4, transition: { duration: 0.2, ease: EASE } };

  // Hero headline — dramatic per-line 3D reveal (flip up + blur + scale)
  const heroTitle = { hidden: {}, show: { transition: { staggerChildren: 0.22, delayChildren: 0.15 } } };
  const heroLine = reduce
    ? fadeUpReduced
    : {
      hidden: { opacity: 0, y: 60, rotateX: -75, scale: 0.92, filter: "blur(10px)" },
      show: { opacity: 1, y: 0, rotateX: 0, scale: 1, filter: "blur(0px)", transition: { duration: 0.8, ease: EASE } },
    };

  // Four-steps: circle springs in, then its text — staggered within each step
  const stepStagger = { hidden: {}, show: { transition: { staggerChildren: 0.06 } } };

  // Approach section — slowed ~20% (emotional). Pull-quote lands last & slowest.
  const approachText = reduce
    ? fadeUpReduced
    : { hidden: { opacity: 0, y: 3, filter: "blur(4px)" }, show: { opacity: 1, y: 0, filter: "blur(0px)", transition: { duration: 0.55, ease: EASE } } };
  const approachQuote = reduce
    ? fadeUpReduced
    : { hidden: { opacity: 0, y: 3, filter: "blur(4px)" }, show: { opacity: 1, y: 0, filter: "blur(0px)", transition: { duration: 0.65, ease: EASE, delay: 0.4 } } };
  const approachSlide = reduce
    ? slideInRightReduced
    : { hidden: { opacity: 0, x: 40 }, show: { opacity: 1, x: 0, transition: { duration: 0.55, ease: EASE } } };
  const approachLeftUnit = { hidden: {}, show: { transition: { staggerChildren: 0 } } };
  const approachRightStagger = { hidden: {}, show: { transition: { staggerChildren: 0.12, delayChildren: 0.2 } } };

  // Contact form state
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });


  const videoRef1 = useRef(null);
  const videoRef2 = useRef(null);

  // Off-screen pause for looping hero glow
  const heroRef = useRef(null);
  const heroInView = useInView(heroRef, { amount: 0.1 });

  // Off-screen pause for founder loops (Ken Burns + play-button pulse)
  const founderRef = useRef(null);
  const founderInView = useInView(founderRef, { amount: 0.1 });

  // Off-screen pause for waitlist CTA pulse
  const waitlistRef = useRef(null);
  const waitlistInView = useInView(waitlistRef, { amount: 0.1 });

  // Founder loops — off when reduced motion or scrolled off-screen
  const kenBurns =
    reduce || !founderInView
      ? { scale: 1 }
      : { scale: [1, 1.04], transition: { duration: 10, ease: "easeInOut", repeat: Infinity, repeatType: "reverse" } };
  const playRing =
    reduce || !founderInView
      ? { opacity: 0 }
      : { scale: [1, 1.15], opacity: [0.6, 0], transition: { duration: 2, ease: "easeOut", repeat: Infinity } };

  // Founder columns slide in from opposite sides on scroll, then stagger their children.
  const founderLeft = reduce
    ? fadeUpReduced
    : { hidden: { opacity: 0, x: -30 }, show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: EASE, staggerChildren: 0.08 } } };
  const founderRight = reduce
    ? fadeUpReduced
    : { hidden: { opacity: 0, x: 30 }, show: { opacity: 1, x: 0, transition: { duration: 0.6, ease: EASE, staggerChildren: 0.08 } } };

  // Waitlist CTA — soft breathing glow (brand motif), off when reduced/off-screen
  const ctaPulse =
    reduce || !waitlistInView
      ? {}
      : {
        boxShadow: [
          "0 0 0px rgba(255,20,147,0)",
          "0 0 26px rgba(255,20,147,0.55)",
          "0 0 0px rgba(255,20,147,0)",
        ],
        transition: { duration: 3, ease: "easeInOut", repeat: Infinity },
      };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const video1 = videoRef1.current;
    const video2 = videoRef2.current;

    // Set playback speed
    if (video1) {
      video1.playbackRate = 0.5; // 0.5 = half speed, 1.0 = normal, 2.0 = double speed
    }

    if (video2) {
      video2.playbackRate = 0.5;
    }

    // Optional: Add smooth loop transition
    const handleVideoEnd = () => {
      if (video1 && video1.duration - video1.currentTime < 0.1) {
        video1.currentTime = 0;
      }
      if (video2 && video2.duration - video2.currentTime < 0.1) {
        video2.currentTime = 0;
      }
    };

    if (video1) {
      video1.addEventListener('timeupdate', handleVideoEnd);
    }
    if (video2) {
      video2.addEventListener('timeupdate', handleVideoEnd);
    }

    return () => {
      if (video1) {
        video1.removeEventListener('timeupdate', handleVideoEnd);
      }
      if (video2) {
        video2.removeEventListener('timeupdate', handleVideoEnd);
      }
    };
  }, []);

  return (
    <>
      <div className="main">
        <div className="vid-banner-sec hero-banner-sec">
          <img src={bannerimg} alt="banner" className="hero-banner-img d-none d-md-block" />
          <img src={Ellipse} alt="banner" className="hero-banner-img d-block d-md-none" />
          <div className="hero-top" ref={heroRef}>
            {/* <motion.div
              className="hero-glow"
              aria-hidden="true"
              animate={heroInView && !reduce ? { scale: [1, 1.05, 1] } : { scale: 1 }}
              transition={{ duration: 6, ease: "easeInOut", repeat: Infinity }}
            /> */}
            <motion.div
              className="container"
              variants={stagger}
              initial="hidden"
              animate="show"
            >
              <motion.div className="text-center" variants={vScale}>
                <img src={Subtraction_1} alt="banner" className="subtraction-img" />
                <span className="hero-badge">Launching in the UK &ndash; Join the waitlist</span>
              </motion.div>
              <motion.div className="logo" variants={vFadeUp}>
                <img src={newLogo} alt="banner" className="subtraction-img d-none d-md-block" />
                <img src={mobile_logo} alt="banner" className="subtraction-img d-flex d-md-none" />
              </motion.div>
              <motion.h1 className="hero-heading">
                {headingRevealed ? (
                  // Water wave phase — gradient sweeps left-to-right on all text continuously
                  <>
                    <h5>Meet First. <em>Chat</em> Later.</h5>
                  </>
                ) : (
                  <>
                    <h5>Meet First. <em>Chat</em> Later.</h5>
                  </>
                )}
              </motion.h1>
              <motion.p className="hero-sub" variants={vFadeUp}>
                The dating app that replaces swiping with a 60 second video &ndash; built around real human connection &ndash; not endless swiping.
              </motion.p>
              <motion.p className="hero-quote" variants={vFadeUp}>&ldquo;Be <em>happy</em> first. Everything else follows.&rdquo;</motion.p>
              <motion.div className="hero-btns" variants={stagger}>
                <motion.button
                  type="button"
                  className={`hero-btn-primary ${activeBtn === "waitlist" ? "active" : ""}`}
                  onClick={() => { setActiveBtn("waitlist"); setShowModel(true); }}
                  variants={vFadeUp}
                >
                  Free Access &bull; First 1000 Users Only
                </motion.button>
                <motion.button
                  type="button"
                  className={`hero-btn-primary ${activeBtn === "how" ? "active" : ""}`}
                  onClick={() => {
                    setActiveBtn("how");
                    setStepsActive(true);
                    document.getElementById("four-steps-section")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  variants={vFadeUp}
                >
                  See How It Works
                </motion.button>
              </motion.div>
            </motion.div>
          </div>
          <div className="hero-features">
            <motion.div
              className="container"
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={VIEWPORT_REVEAL}
            >
              <motion.p className="hero-features-label" variants={vFadeUp}>WHAT MAKES US DIFFERENT</motion.p>
              <motion.h2 className="hero-features-heading" variants={vFadeUp}>
                Designed to feel<br />
                more <em>human.</em>
              </motion.h2>
              <motion.p className="hero-features-desc" variants={vFadeUp}>
                LoveHappiness&reg; combines real-time video connection with a calmer, more
                intentional dating experience designed around emotional wellbeing.
              </motion.p>
              <motion.div className="hero-feature-cards d-none d-md-block" variants={vFadeUp}>
                <div className="hero-feature-track">
                  {[...heroFeatures, ...heroFeatures].map((f, i) => (
                    <div
                      className="hero-feature-card"
                      key={i}
                      aria-hidden={i >= heroFeatures.length}
                    >
                      <div className="hero-feature-icon">
                        <img src={f.icon} alt="media" />
                      </div>
                      <p>{f.text}</p>
                    </div>
                  ))}
                </div>
              </motion.div>

              <div className="hero-feature-swiper d-block d-md-none" onDoubleClick={toggleFeatureAutoplay}>
                <Swiper
                  onSwiper={(s) => { featureSwiperRef.current = s; }}
                  modules={[Autoplay, FreeMode]}
                  slidesPerView={1.8}
                  spaceBetween={16}
                  loop={true}
                  freeMode={{ enabled: true, momentum: true, sticky: false }}
                  speed={2800}
                  allowTouchMove={true}
                  grabCursor={true}
                  autoplay={
                    reduce
                      ? false
                      : {
                        delay: 0,
                        disableOnInteraction: false,
                        // pauseOnMouseEnter: false,
                      }
                  }
                  breakpoints={{
                    480: { slidesPerView: 1.2 },
                    640: { slidesPerView: 1.2 },
                  }}
                >
                  {heroFeatures.map((f, i) => (
                    <SwiperSlide key={i} className="hero-feature-slide">
                      <div className="hero-feature-card">
                        <div className="hero-feature-icon">
                          <img src={f.icon} alt="media" />
                        </div>
                        <p>{f.text}</p>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              <motion.p className="hero-features-note" variants={vFadeUp}>
                The first 1,000 users receive complimentary access for a month with up to 5 video calls included per day.
              </motion.p>
            </motion.div>
          </div>
          {showModel && (
            <WaitlistPopup
              showModel={showModel}
              setShowModel={setShowModel}
              initialEmail={activeBtn === "waitlist" ? waitlistEmail : ""}
            />
          )}
        </div>

        <section className="behind-app-section" aria-labelledby="behind-app-heading">
          <div className="container">
            <motion.div
              className="behind-app-header container text-center"
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={VIEWPORT_REVEAL}
            >
              <motion.p className="behind-app-label" variants={vFadeUp}>BEHIND THE APP</motion.p>
              <motion.h2 id="behind-app-heading" className="behind-app-heading" variants={vFadeUp}>
                See LoveHappiness in <em>Action</em>
              </motion.h2>
            </motion.div>

            <div className="behind-app-carousel">
              <div className="behind-app-track">
                {behindTheAppSlides.map((slide) => {
                  const open = () => setBehindVideo({ src: slide.video, poster: slide.image, caption: slide.caption });
                  return (
                    <div
                      className="behind-app-slide"
                      key={slide.caption}
                      role="button"
                      tabIndex={0}
                      aria-label={`Play video: ${slide.caption}`}
                      onClick={open}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          open();
                        }
                      }}
                    >
                      <figure className="behind-app-card">
                        <div className="behind-app-media">
                          <img
                            className="behind-app-image"
                            src={slide.image}
                            alt={`LoveHappiness app preview: ${slide.caption}`}
                          />
                          <span className="behind-app-shade" aria-hidden="true" />
                          <img className="behind-app-play" src={video_play} alt="" aria-hidden="true" />
                        </div>
                        <figcaption>{slide.caption}</figcaption>
                      </figure>
                    </div>
                  );
                })}
              </div>
            </div>

            {behindVideo &&
              createPortal(
                <div
                  className="behind-video-modal"
                  role="dialog"
                  aria-modal="true"
                  aria-label={behindVideo.caption}
                  onClick={() => setBehindVideo(null)}
                >
                  {/* frame shrink-wraps the video so the close button sits on its corner */}
                  <div className="behind-video-frame" onClick={(e) => e.stopPropagation()}>
                    <video
                      ref={behindVideoRef}
                      className="behind-video-player"
                      src={behindVideo.src}
                      poster={behindVideo.poster}
                      controls
                      autoPlay
                      playsInline
                      preload="auto"
                      onEnded={() => setBehindVideo(null)}
                    />
                    <button
                      type="button"
                      className="behind-video-close"
                      aria-label="Close video"
                      onClick={() => setBehindVideo(null)}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" width="18" height="18" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"></path>
                      </svg>
                    </button>
                  </div>
                </div>,
                document.body
              )}

            <div className="behind-app-socials" aria-label="Follow LoveHappiness on social media">
              <a
                href="https://www.instagram.com/lovehappinessapp?igsh=bzBwc2d1bHE5aWtl&utm_source=qr"
                target="_blank"
                rel="noreferrer"
                aria-label="Follow LoveHappiness on Instagram"
              >
                <img src={instaIcon2} alt="" aria-hidden="true" />
                <span>Follow on Instagram</span>
              </a>
              <a
                href="https://www.tiktok.com/@lovehappinessapp?_r=1&_t=ZN-97j3236nZCg"
                target="_blank"
                rel="noreferrer"
                aria-label="Follow LoveHappiness on TikTok"
              >
                <img src={tiktok_icon2} alt="" aria-hidden="true" />
                <span>Follow on TikTok</span>
              </a>
            </div>
          </div>
        </section>

        <div className={`four-steps-section ${stepsActive ? "active" : ""}`} id="four-steps-section">
          <div className="container">
            <motion.div
              className="four-steps-inner text-center"
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={VIEWPORT_REVEAL}
            >
              <motion.p className="four-steps-label" vvariants={vFadeUp}>HOW IT WORKS</motion.p>
              <motion.h2 className="four-steps-heading" variants={vFadeUp}>
                Four steps<br />
                One <em>real connection.</em>
              </motion.h2>
              <motion.p className="four-steps-sub" variants={vFadeUp}>
                No swiping. No guessing. Just you, them and 60 seconds to feel something real.
              </motion.p>
              <motion.div className="four-steps-grid" variants={staggerSlow}>
                <motion.div className="four-step-card" variants={stepStagger}>
                  <motion.div className="four-step-number four-step-number--pink" variants={vScale}>1</motion.div>
                  <motion.div className="four-step-body" variants={vFadeUp}>
                    <div className="four-step-icon">
                      <img src={media_icon6} alt="heart" className="user_icon" />
                      <span className="four-step-number--pink-text">Browse profiles</span>
                    </div>
                    <p>Scroll through real, verified profiles. No algorithm. No swipe. When someone catches your eye &ndash; you act.</p>
                  </motion.div>
                </motion.div>
                <motion.div className="four-step-card" variants={stepStagger}>
                  <motion.div className="four-step-number four-step-number--blue" variants={vScale}>2</motion.div>
                  <motion.div className="four-step-body" variants={vFadeUp}>
                    <div className="four-step-icon">
                      <img src={media_icon5} alt="heart" />
                      <span className="four-step-number--blue-text">Video call &ndash; right now or book a time</span>
                    </div>
                    <p>Scroll through real, verified profiles. No algorithm. No swipe. When someone catches your eye - you act.</p>
                  </motion.div>
                </motion.div>
                <motion.div className="four-step-card" variants={stepStagger}>
                  <motion.div className="four-step-number four-step-number--yellow" variants={vScale}>3</motion.div>
                  <motion.div className="four-step-body" variants={vFadeUp}>
                    <div className="four-step-icon">
                      <img src={media_icon8} alt="heart" />
                      <span className="four-step-number--yellow-text">60 seconds then you decide</span>
                    </div>
                    <p>Your call lasts 60 seconds. If you both feel something, press the green button and the call continues for 3 minutes.</p>
                  </motion.div>
                </motion.div>
                <motion.div className="four-step-card" variants={stepStagger}>
                  <motion.div className="four-step-number four-step-number--green" variants={vScale}>4</motion.div>
                  <motion.div className="four-step-body" variants={vFadeUp}>
                    <div className="four-step-icon">
                      <img src={media_icon7} alt="heart" />
                      <span className="four-step-number--green-text">If it is a no - we handle it kindly</span>
                    </div>
                    <p>If one person ends the call, the other receives a warm, thoughtful message from LoveHappiness® Because nobody should feel bad for showing up.</p>
                    <p className="four-steps-footer">
                      We built kindness into the moment every other app gets wrong.
                    </p>
                  </motion.div>
                </motion.div>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <div className="why-section">
          <div className="container">
            <motion.div
              className="why-inner"
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={VIEWPORT_REVEAL}
            >
              <motion.p className="why-label" variants={vFadeUp}>WHY LOVEHAPPINESS®</motion.p>
              <motion.h2 className="why-heading" variants={vFadeUp}>
                Built around <em>authentic connection, emotional wellbeing,</em> and helping people meet genuinely from the very start.
              </motion.h2>
              <motion.p className="why-sub" variants={vFadeUp}>
                Most dating apps are designed to keep you scrolling.
              </motion.p>
              <motion.p className="why-sub --last" variants={vFadeUp}>
                LoveHappiness® is designed to make connections feel human again.
              </motion.p>
              <motion.div className="why-grid" variants={stagger}>
                <motion.div className="why-card" variants={vFadeUp} whileHover={cardHover}>
                  <div className="why-card-header">
                    <img src={media_icon17} alt="media" />
                    <span>Video First</span>
                  </div>
                  <p>60 seconds to see the real person then decide before messaging begins.</p>
                </motion.div>
                <motion.div className="why-card" variants={vFadeUp} whileHover={cardHover}>
                  <div className="why-card-header">
                    <img src={media_icon12} alt="media" />
                    <span>Designed for Emotional Wellbeing</span>
                  </div>
                  <p>Built to feel calmer, kinder, and more intentional.</p>
                </motion.div>
                <motion.div className="why-card" variants={vFadeUp} whileHover={cardHover}>
                  <div className="why-card-header">
                    <img src={media_icon13} alt="media" />
                    <span>No Endless Swiping</span>
                  </div>
                  <p>Less endless scrolling. More real connections.</p>
                </motion.div>
                <motion.div className="why-card" variants={vFadeUp} whileHover={cardHover}>
                  <div className="why-card-header">
                    <img src={media_icon14} alt="media" />
                    <span>Real-Time Chemistry</span>
                  </div>
                  <p>Know quickly whether there is a genuine connection.</p>
                </motion.div>
                <motion.div className="why-card" variants={vFadeUp} whileHover={cardHover}>
                  <div className="why-card-header">
                    <img src={media_icon10} alt="media" />
                    <span>Balanced Experience</span>
                  </div>
                  <p>Conceived for an authentic experience for everyone.</p>
                </motion.div>
                <motion.div className="why-card" variants={vFadeUp} whileHover={cardHover}>
                  <div className="why-card-header">
                    <img src={media_icon11} alt="media" />
                    <span>Modern Dating, Reimagined</span>
                  </div>
                  <p>A premium experience focused on quality over quantity.</p>
                </motion.div>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <div className="approach-section">
          <div className="container">
            <div className="approach-inner">
              <motion.div
                className="approach-left"
                variants={approachLeftUnit}
                initial="hidden"
                whileInView="show"
                viewport={VIEWPORT_REVEAL}
              >
                <motion.p className="approach-label" variants={approachText}>A DIFFERENT APPROACH</motion.p>
                <motion.h2 className="approach-heading" variants={approachText}>
                  Even rejection<br />
                  should feel <em>human.</em>
                </motion.h2>
                <motion.p className="approach-body" variants={approachText}>
                  LoveHappiness&reg; is not about finding a relationship. It is about loving happiness itself and letting connection add to that.
                </motion.p>
                <motion.p className="approach-body" variants={approachText}>
                  LoveHappiness&reg; was built on the belief that putting yourself out there should never leave you feeling worse about yourself.
                </motion.p>
                <motion.p className="approach-quote" variants={approachQuote}>
                  &ldquo;Whatever connection you find here should add to <em>your happiness.</em> Never define it.&rdquo;
                </motion.p>
              </motion.div>
              <motion.div
                className="approach-right"
                variants={approachRightStagger}
                initial="hidden"
                whileInView="show"
                viewport={VIEWPORT_REVEAL}
              >
                <motion.div className="approach-card approach-card--teal" variants={approachSlide}>
                  <div className="approach-card-icon">
                    <img src={media_icon5} alt="media" />
                  </div>
                  <h4>Your worth is not defined by your matches</h4>
                  <p>Every feature in this app was built around one belief: you are enough before, during, and after every call.</p>
                </motion.div>
                <motion.div className="approach-card approach-card--pink" variants={approachSlide}>
                  <div className="approach-card-icon">
                    <img src={media_icon16} alt="media" />
                  </div>
                  <h4>Rejection does not have to feel like rejection</h4>
                  <p>Our red button sends a kind, human message &ndash; written with care &ndash; so nobody walks away feeling less than they are.</p>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="founder-section" ref={founderRef}>
          <div className="container">
            <div className="founder-section-inner">
              <motion.div
                className="founder-section-left"
                variants={founderLeft}
                initial="hidden"
                whileInView="show"
                viewport={VIEWPORT_REVEAL}
              >
                <motion.p className="founder-section-label" variants={vFadeUp}>A MESSAGE FROM THE FOUNDER</motion.p>
                <motion.blockquote className="founder-section-quote d-none d-md-block" variants={vFadeUp}>
                  “I know what it feels like to put yourself out there on a dating app and come away feeling worse about yourself than when you started. <br></br><em>I built LoveHappiness® to change that.”</em>
                </motion.blockquote>
                <motion.blockquote className="founder-section-quote d-block d-md-none" variants={vFadeUp}>
                  “I know what it feels like to put yourself out there on a dating app and come away feeling worse about yourself than when you started. <em>I built LoveHappiness® to change that.”</em>
                </motion.blockquote>
                <motion.div className="founder-video-wrap d-flex d-md-none" >
                  <div className="founder-video-thumb" style={{ position: "relative", }}>
                    {/* {!isFounderVideoPlaying ? ( */}
                    <>
                      <motion.img
                        src={media_img2}
                        alt="founder"
                        className="founder-video-img"
                      // onClick={handleFounderVideoPlay}
                      // style={{ transformOrigin: "center" }}
                      // initial={false}
                      // animate={kenBurns}
                      />
                      {/* <div className="founder-play-btn" onClick={handleFounderVideoPlay}> */}
                      {/* <motion.span className="founder-play-ring" aria-hidden="true" animate={playRing} /> */}
                      {/* <img src={video_play} alt="play" /> */}
                      {/* </div> */}
                    </>
                    {/* ) : (
                      <video
                        ref={founderVideoRef}
                        src={FounderVid}
                        controls
                      />
                    )} */}
                  </div>
                </motion.div>
                <motion.p className="founder-section-body" variants={vFadeUp}>
                  I&rsquo;m Sarah Malik a registered psychotherapist and the founder of LoveHappiness&reg;. I have used dating apps and I have also felt the hollow disappointment of a conversation that goes nowhere, the sting of being ignored, the quiet erosion that comes from years of swiping through faces and wondering why none of it ever feels real. I know that feeling from the inside. And as someone who understands human behaviour and emotional wellbeing, I also know exactly why it happens.
                </motion.p>
                <motion.p className="founder-section-body" variants={vFadeUp}>
                  Dating apps were not designed around your happiness. They were designed to keep you scrolling. There is a difference, and it matters. So I decided to build something that puts you first.<br />
                  Not your profile.<br />
                  Not your match count.<br />
                  <strong>You.</strong>
                </motion.p>
              </motion.div>
              <motion.div
                className="founder-section-right"
                variants={founderRight}
                initial="hidden"
                whileInView="show"
                viewport={VIEWPORT_REVEAL}
              >
                <motion.div className="founder-video-wrap d-none d-md-block" variants={fadeIn}>
                  <div className="founder-video-thumb" style={{ position: "relative", }}>
                    {/* {!isFounderVideoPlaying ? ( */}
                    <>
                      <motion.img
                        src={media_img}
                        alt="founder"
                        className="founder-video-img"
                      // onClick={handleFounderVideoPlay}
                      // style={{ transformOrigin: "center" }}
                      // initial={false}
                      // animate={kenBurns}
                      />
                      {/* <div className="founder-play-btn" onClick={handleFounderVideoPlay}> */}
                      {/* <motion.span className="founder-play-ring" aria-hidden="true" animate={playRing} /> */}
                      {/* <img src={video_play} alt="play" /> */}
                      {/* </div> */}
                    </>
                    {/* ) : (
                      <video
                        ref={founderVideoRef}
                        src={FounderVid}
                        controls
                      />
                    )} */}
                  </div>
                </motion.div>
                <motion.p className="founder-section-body" variants={vFadeUp}>
                  Six years. Every penny self-funded. Built alongside my brother, who believed in this idea before anyone else did. LoveHappiness® was built slowly, carefully, and with one intention, to create a space where connection feels human again.
                </motion.p>
                <motion.p className="founder-section-body" variants={vFadeUp}>
                  This app is not only built around finding a relationship. It is built around the belief that you deserve to feel good about yourself before, during, and after every single interaction on it. Whatever connection you find here should add to your happiness. Never define it.
                </motion.p>
                {/* <motion.p className="founder-section-body" variants={vFadeUp}>
                  Welcome to LoveHappiness&reg;
                </motion.p> */}
                <motion.div className="founder-sig" variants={vFadeUp}>
                  <p className="founder-sig-name">Sarah Malik</p>
                  <p className="founder-sig-title">Founder, LoveHappiness&reg;</p>
                  <p className="founder-sig-title">Registered Psychotherapist &middot; Manchester, UK</p>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </div>

        <div className="be-among-section" ref={waitlistRef}>
          <div className="container">
            <motion.div
              className="be-among-inner text-center"
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={VIEWPORT_REVEAL}
            >
              <motion.p className="be-among-label" variants={vFadeUp}>JOIN THE WAITLIST</motion.p>
              <motion.h2 className="be-among-heading" variants={vFadeUp}>
                Be among the <em>first</em> to<br />
                experience LoveHappiness&reg;
              </motion.h2>
              <motion.p className="be-among-sub" variants={vFadeUp}>We&rsquo;re launching soon in the UK.</motion.p>
              <motion.p className="be-among-desc" variants={vFadeUp}>
                Join the waitlist today and receive early access updates, launch news, and complimentary premium access opportunities.
              </motion.p>
              <motion.form
                className="be-among-form"
                variants={vFadeUp}
                onSubmit={handleWaitlistSubmit}
              >
                <div className="be-among-input-wrap">
                  <span className="be-among-mail-icon">
                    <img src={gmail_icon} alt="email" />
                  </span>
                  <input
                    type="email"
                    className="be-among-input"
                    placeholder="Your email"
                    value={waitlistEmail}
                    onChange={(e) => setWaitlistEmail(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleWaitlistSubmit(e);
                    }}
                  />
                </div>
                <motion.button type="submit" className="be-among-btn" animate={ctaPulse}>I&rsquo;m In</motion.button>
              </motion.form>
              <motion.p className="be-among-note" variants={vFadeUp}>
                The first 1,000 users receive complimentary access for a month with up to 5 video calls included per day.
              </motion.p>
            </motion.div>
          </div>
        </div>

        <div className="founder-quote-section">
          <div className="container">
            <motion.div
              className="founder-quote-inner text-center"
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={VIEWPORT_REVEAL}
            >
              <motion.blockquote variants={vFadeUp}>
                <p>
                  &ldquo;LoveHappiness&reg; was built carefully, intentionally, and completely
                  self-funded. There were no huge investors or big teams behind it, just
                  someone who understands how hard modern dating can feel and wanted to
                  create something kinder. I&rsquo;m not a businesswoman chasing numbers.
                  I&rsquo;m simply someone trying to build confidence, genuine connection,
                  and take others on that journey with me who may have experienced the
                  same feelings I have.&rdquo;
                </p>
              </motion.blockquote>
              <motion.div className="founder-attribution" variants={vFadeUp}>
                <p className="founder-name">Sarah Malik</p>
                <p className="founder-title">Founder, LoveHappiness&reg;</p>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
